import { render, staticRenderFns } from "./sortingformdifferent.vue?vue&type=template&id=589d1043&scoped=true&"
import script from "./sortingformdifferent.vue?vue&type=script&lang=js&"
export * from "./sortingformdifferent.vue?vue&type=script&lang=js&"
import style0 from "./sortingformdifferent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./sortingformdifferent.vue?vue&type=style&index=1&id=589d1043&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589d1043",
  null
  
)

export default component.exports